/**
* @file: 号码搜索
* @author: wence
*/

import React, {PureComponent} from 'react';
import PropType from 'prop-types';
import {connect} from 'react-redux';
import SearchBar from '../../components/searchBar';

import './index.less';
const historyKey = 'numberSearch';

class NumberSearch extends PureComponent {
    static propTypes = {
        history: PropType.object,
        navigationList: PropType.object
    }

    constructor(props) {
        super(props);

        const storage = localStorage.getItem(historyKey);
        const historyList = storage ? JSON.parse(storage) : [];

        this.state = {
            historyList,
            searchValue: ''
        };

        if (this.isPC()) {
            location.href = '/haoma/search';
        }
    }

    changeHistoryList = list => {
        localStorage.setItem(historyKey, JSON.stringify(list));
        this.setState({historyList: list});
    }

    onChange = value => {
        this.setState({searchValue: value});
    }

    findId = list => {
        let id = '';
        const loop = list => {
            list.forEach(item => {
                if (!item) {
                    return;
                }
                if (item.navigation_name === '号码认证') {
                    id = item.id;
                }
                else if (item.child && item.child.length > 0) {
                    loop(item.child);
                }
            });
        };

        loop(list);
        return id;
    }

    onSubmit = value => {
        if (!((value || '').trim())) {
            return;
        }

        const historyList = [].concat(this.state.historyList);
        const index = historyList.indexOf(value);

        if (index < 0) {
            historyList.push(value);
        }

        this.changeHistoryList(historyList);

        location.href = '/m/haoma/result/' + value;
    }

    removeHistoryItem = (index, e) => {
        e.preventDefault();
        const historyList = [].concat(this.state.historyList);
        historyList.splice(index, 1);

        this.changeHistoryList(historyList);
        this.setState({historyList});
    }

    render() {
        const {searchValue, historyList} = this.state;

        return (
            <div className="number-search">
                <SearchBar
                    value={searchValue}
                    onChange={this.onChange}
                    onSubmit={this.onSubmit}
                    onCancel={() => {
                        const navigationList = this.props.navigationList || {};
                        const list = navigationList.itemlist || [];
                        const id = this.findId(list);
                        if (id) {
                            location.href = '/m/product/' + id;
                        }
                        else {
                            this.props.history.goBack();
                        }
                    }}
                    placeholder="请输入要查询的电话号码或关键字"
                    autoFocus isShowCancel />
                <div className="search-history">
                    <div className="search-history-title">搜索历史</div>
                    {historyList.map((text, index) => {
                        return (
                            <a
                                href={`/m/haoma/result/${text}`}
                                className="search-history-item" key={index}>
                                {text}
                                <img
                                    onClick={this.removeHistoryItem.bind(this, index)}
                                    src={require('../../asset/svg/icon_cancel.svg')} alt="cancel" />
                            </a>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default connect(state => ({navigationList: state.navigationList}))(NumberSearch);



// WEBPACK FOOTER //
// ./src/containers/numberSearch/index.jsx